import styled from "styled-components";

export const ModalWrapper = styled.div`
  border-radius: 20px;
  background-color: white;
  max-height: inherit;
  width: 100%;
  overflow: hidden;
`;
